"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * alertfan-app API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.5.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagsApi = exports.TagsApiFactory = exports.TagsApiFp = exports.TagsApiAxiosParamCreator = exports.SilencesApi = exports.SilencesApiFactory = exports.SilencesApiFp = exports.SilencesApiAxiosParamCreator = exports.PropertiesApi = exports.PropertiesApiFactory = exports.PropertiesApiFp = exports.PropertiesApiAxiosParamCreator = exports.HistoryApi = exports.HistoryApiFactory = exports.HistoryApiFp = exports.HistoryApiAxiosParamCreator = exports.ConfigurationApi = exports.ConfigurationApiFactory = exports.ConfigurationApiFp = exports.ConfigurationApiAxiosParamCreator = exports.AlertsApi = exports.AlertsApiFactory = exports.AlertsApiFp = exports.AlertsApiAxiosParamCreator = exports.Transport = exports.Status = exports.SilenceState = exports.Severity = exports.MatchingRuleDiscriminator = exports.DayOfWeek = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.DayOfWeek = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MatchingRuleDiscriminator = {
    All: 'ALL',
    None: 'NONE',
    ContainsAll: 'CONTAINS_ALL',
    ContainsAny: 'CONTAINS_ANY',
    ContainsNone: 'CONTAINS_NONE',
    ContainsExact: 'CONTAINS_EXACT',
    And: 'AND',
    Or: 'OR',
    Xor: 'XOR'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Severity = {
    Debug: 'DEBUG',
    Info: 'INFO',
    Warning: 'WARNING',
    Severe: 'SEVERE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SilenceState = {
    Expired: 'EXPIRED',
    Active: 'ACTIVE',
    Pending: 'PENDING'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Status = {
    Firing: 'FIRING',
    Resolved: 'RESOLVED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Transport = {
    Smtp: 'SMTP',
    Smtps: 'SMTPS',
    SmtpTls: 'SMTP_TLS'
};
/**
 * AlertsApi - axios parameter creator
 * @export
 */
const AlertsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Array<AlertCancellationRequest>} alertCancellationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearAlerts: (alertCancellationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'alertCancellationRequest' is not null or undefined
            (0, common_1.assertParamExists)('clearAlerts', 'alertCancellationRequest', alertCancellationRequest);
            const localVarPath = `/alerts/clear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alertCancellationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<IsActiveRequest>} isActiveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isActive: (isActiveRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'isActiveRequest' is not null or undefined
            (0, common_1.assertParamExists)('isActive', 'isActiveRequest', isActiveRequest);
            const localVarPath = `/alerts/isActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(isActiveRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<Alert>} alert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAlerts: (alert, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'alert' is not null or undefined
            (0, common_1.assertParamExists)('postAlerts', 'alert', alert);
            const localVarPath = `/alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alert, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AlertsApiAxiosParamCreator = AlertsApiAxiosParamCreator;
/**
 * AlertsApi - functional programming interface
 * @export
 */
const AlertsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AlertsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {Array<AlertCancellationRequest>} alertCancellationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearAlerts(alertCancellationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clearAlerts(alertCancellationRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAlerts(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<IsActiveRequest>} isActiveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isActive(isActiveRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.isActive(isActiveRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<Alert>} alert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAlerts(alert, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postAlerts(alert, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AlertsApiFp = AlertsApiFp;
/**
 * AlertsApi - factory interface
 * @export
 */
const AlertsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AlertsApiFp)(configuration);
    return {
        /**
         *
         * @param {Array<AlertCancellationRequest>} alertCancellationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearAlerts(alertCancellationRequest, options) {
            return localVarFp.clearAlerts(alertCancellationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts(options) {
            return localVarFp.getAlerts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<IsActiveRequest>} isActiveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isActive(isActiveRequest, options) {
            return localVarFp.isActive(isActiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<Alert>} alert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAlerts(alert, options) {
            return localVarFp.postAlerts(alert, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AlertsApiFactory = AlertsApiFactory;
/**
 * AlertsApi - object-oriented interface
 * @export
 * @class AlertsApi
 * @extends {BaseAPI}
 */
class AlertsApi extends base_1.BaseAPI {
    /**
     *
     * @param {Array<AlertCancellationRequest>} alertCancellationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    clearAlerts(alertCancellationRequest, options) {
        return (0, exports.AlertsApiFp)(this.configuration).clearAlerts(alertCancellationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    getAlerts(options) {
        return (0, exports.AlertsApiFp)(this.configuration).getAlerts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<IsActiveRequest>} isActiveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    isActive(isActiveRequest, options) {
        return (0, exports.AlertsApiFp)(this.configuration).isActive(isActiveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<Alert>} alert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertsApi
     */
    postAlerts(alert, options) {
        return (0, exports.AlertsApiFp)(this.configuration).postAlerts(alert, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AlertsApi = AlertsApi;
/**
 * ConfigurationApi - axios parameter creator
 * @export
 */
const ConfigurationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateApiKey: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/configuration/generateApiKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregators: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/configuration/aggregators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultAggregator: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/configuration/aggregator/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSenders: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/configuration/senders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadAlertmanagerConfig: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/configuration/reload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<Aggregator>} aggregator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAggregators: (aggregator, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'aggregator' is not null or undefined
            (0, common_1.assertParamExists)('setAggregators', 'aggregator', aggregator);
            const localVarPath = `/configuration/aggregators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(aggregator, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<Sender>} sender
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSenders: (sender, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sender' is not null or undefined
            (0, common_1.assertParamExists)('setSenders', 'sender', sender);
            const localVarPath = `/configuration/senders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sender, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {TestMatchingRuleRequest} [testMatchingRuleRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testMatchingRule: (testMatchingRuleRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/configuration/test/matchingRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(testMatchingRuleRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ConfigurationApiAxiosParamCreator = ConfigurationApiAxiosParamCreator;
/**
 * ConfigurationApi - functional programming interface
 * @export
 */
const ConfigurationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ConfigurationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateApiKey(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateApiKey(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregators(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAggregators(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultAggregator(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDefaultAggregator(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSenders(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSenders(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadAlertmanagerConfig(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reloadAlertmanagerConfig(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<Aggregator>} aggregator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAggregators(aggregator, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setAggregators(aggregator, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<Sender>} sender
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSenders(sender, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setSenders(sender, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {TestMatchingRuleRequest} [testMatchingRuleRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testMatchingRule(testMatchingRuleRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testMatchingRule(testMatchingRuleRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ConfigurationApiFp = ConfigurationApiFp;
/**
 * ConfigurationApi - factory interface
 * @export
 */
const ConfigurationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ConfigurationApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateApiKey(options) {
            return localVarFp.generateApiKey(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregators(options) {
            return localVarFp.getAggregators(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultAggregator(options) {
            return localVarFp.getDefaultAggregator(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSenders(options) {
            return localVarFp.getSenders(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadAlertmanagerConfig(options) {
            return localVarFp.reloadAlertmanagerConfig(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<Aggregator>} aggregator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAggregators(aggregator, options) {
            return localVarFp.setAggregators(aggregator, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<Sender>} sender
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSenders(sender, options) {
            return localVarFp.setSenders(sender, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TestMatchingRuleRequest} [testMatchingRuleRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testMatchingRule(testMatchingRuleRequest, options) {
            return localVarFp.testMatchingRule(testMatchingRuleRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ConfigurationApiFactory = ConfigurationApiFactory;
/**
 * ConfigurationApi - object-oriented interface
 * @export
 * @class ConfigurationApi
 * @extends {BaseAPI}
 */
class ConfigurationApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    generateApiKey(options) {
        return (0, exports.ConfigurationApiFp)(this.configuration).generateApiKey(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    getAggregators(options) {
        return (0, exports.ConfigurationApiFp)(this.configuration).getAggregators(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    getDefaultAggregator(options) {
        return (0, exports.ConfigurationApiFp)(this.configuration).getDefaultAggregator(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    getSenders(options) {
        return (0, exports.ConfigurationApiFp)(this.configuration).getSenders(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    reloadAlertmanagerConfig(options) {
        return (0, exports.ConfigurationApiFp)(this.configuration).reloadAlertmanagerConfig(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<Aggregator>} aggregator
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    setAggregators(aggregator, options) {
        return (0, exports.ConfigurationApiFp)(this.configuration).setAggregators(aggregator, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<Sender>} sender
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    setSenders(sender, options) {
        return (0, exports.ConfigurationApiFp)(this.configuration).setSenders(sender, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TestMatchingRuleRequest} [testMatchingRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    testMatchingRule(testMatchingRuleRequest, options) {
        return (0, exports.ConfigurationApiFp)(this.configuration).testMatchingRule(testMatchingRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ConfigurationApi = ConfigurationApi;
/**
 * HistoryApi - axios parameter creator
 * @export
 */
const HistoryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AlertHistoryRequestDTO} [alertHistoryRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory: (alertHistoryRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/history/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alertHistoryRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.HistoryApiAxiosParamCreator = HistoryApiAxiosParamCreator;
/**
 * HistoryApi - functional programming interface
 * @export
 */
const HistoryApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.HistoryApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {AlertHistoryRequestDTO} [alertHistoryRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory(alertHistoryRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHistory(alertHistoryRequestDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.HistoryApiFp = HistoryApiFp;
/**
 * HistoryApi - factory interface
 * @export
 */
const HistoryApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.HistoryApiFp)(configuration);
    return {
        /**
         *
         * @param {AlertHistoryRequestDTO} [alertHistoryRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory(alertHistoryRequestDTO, options) {
            return localVarFp.getHistory(alertHistoryRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.HistoryApiFactory = HistoryApiFactory;
/**
 * HistoryApi - object-oriented interface
 * @export
 * @class HistoryApi
 * @extends {BaseAPI}
 */
class HistoryApi extends base_1.BaseAPI {
    /**
     *
     * @param {AlertHistoryRequestDTO} [alertHistoryRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    getHistory(alertHistoryRequestDTO, options) {
        return (0, exports.HistoryApiFp)(this.configuration).getHistory(alertHistoryRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.HistoryApi = HistoryApi;
/**
 * PropertiesApi - axios parameter creator
 * @export
 */
const PropertiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} property
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProperty: (property, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'property' is not null or undefined
            (0, common_1.assertParamExists)('deleteProperty', 'property', property);
            const localVarPath = `/properties/{property}`
                .replace(`{${"property"}}`, encodeURIComponent(String(property)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} property
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProperty: (property, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'property' is not null or undefined
            (0, common_1.assertParamExists)('getProperty', 'property', property);
            const localVarPath = `/properties/{property}`
                .replace(`{${"property"}}`, encodeURIComponent(String(property)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} property
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProperty: (property, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'property' is not null or undefined
            (0, common_1.assertParamExists)('setProperty', 'property', property);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('setProperty', 'body', body);
            const localVarPath = `/properties/{property}`
                .replace(`{${"property"}}`, encodeURIComponent(String(property)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PropertiesApiAxiosParamCreator = PropertiesApiAxiosParamCreator;
/**
 * PropertiesApi - functional programming interface
 * @export
 */
const PropertiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PropertiesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} property
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProperty(property, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProperty(property, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} property
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProperty(property, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProperty(property, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} property
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProperty(property, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setProperty(property, body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PropertiesApiFp = PropertiesApiFp;
/**
 * PropertiesApi - factory interface
 * @export
 */
const PropertiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PropertiesApiFp)(configuration);
    return {
        /**
         *
         * @param {string} property
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProperty(property, options) {
            return localVarFp.deleteProperty(property, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} property
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProperty(property, options) {
            return localVarFp.getProperty(property, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} property
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProperty(property, body, options) {
            return localVarFp.setProperty(property, body, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PropertiesApiFactory = PropertiesApiFactory;
/**
 * PropertiesApi - object-oriented interface
 * @export
 * @class PropertiesApi
 * @extends {BaseAPI}
 */
class PropertiesApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} property
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    deleteProperty(property, options) {
        return (0, exports.PropertiesApiFp)(this.configuration).deleteProperty(property, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} property
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    getProperty(property, options) {
        return (0, exports.PropertiesApiFp)(this.configuration).getProperty(property, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} property
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    setProperty(property, body, options) {
        return (0, exports.PropertiesApiFp)(this.configuration).setProperty(property, body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PropertiesApi = PropertiesApi;
/**
 * SilencesApi - axios parameter creator
 * @export
 */
const SilencesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {SilenceRequest} [silenceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSilence: (silenceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/silences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(silenceRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSilence: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteSilence', 'id', id);
            const localVarPath = `/silences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSilence: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getSilence', 'id', id);
            const localVarPath = `/silences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [showExpired]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSilences: (showExpired, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/silences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (showExpired !== undefined) {
                localVarQueryParameter['showExpired'] = showExpired;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SilencesApiAxiosParamCreator = SilencesApiAxiosParamCreator;
/**
 * SilencesApi - functional programming interface
 * @export
 */
const SilencesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SilencesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {SilenceRequest} [silenceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSilence(silenceRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addSilence(silenceRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSilence(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSilence(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSilence(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSilence(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [showExpired]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSilences(showExpired, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSilences(showExpired, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SilencesApiFp = SilencesApiFp;
/**
 * SilencesApi - factory interface
 * @export
 */
const SilencesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SilencesApiFp)(configuration);
    return {
        /**
         *
         * @param {SilenceRequest} [silenceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSilence(silenceRequest, options) {
            return localVarFp.addSilence(silenceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSilence(id, options) {
            return localVarFp.deleteSilence(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSilence(id, options) {
            return localVarFp.getSilence(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [showExpired]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSilences(showExpired, options) {
            return localVarFp.getSilences(showExpired, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SilencesApiFactory = SilencesApiFactory;
/**
 * SilencesApi - object-oriented interface
 * @export
 * @class SilencesApi
 * @extends {BaseAPI}
 */
class SilencesApi extends base_1.BaseAPI {
    /**
     *
     * @param {SilenceRequest} [silenceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SilencesApi
     */
    addSilence(silenceRequest, options) {
        return (0, exports.SilencesApiFp)(this.configuration).addSilence(silenceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SilencesApi
     */
    deleteSilence(id, options) {
        return (0, exports.SilencesApiFp)(this.configuration).deleteSilence(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SilencesApi
     */
    getSilence(id, options) {
        return (0, exports.SilencesApiFp)(this.configuration).getSilence(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [showExpired]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SilencesApi
     */
    getSilences(showExpired, options) {
        return (0, exports.SilencesApiFp)(this.configuration).getSilences(showExpired, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SilencesApi = SilencesApi;
/**
 * TagsApi - axios parameter creator
 * @export
 */
const TagsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommonKnownTags: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestBody' is not null or undefined
            (0, common_1.assertParamExists)('addCommonKnownTags', 'requestBody', requestBody);
            const localVarPath = `/tags/common`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addKnownTags: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestBody' is not null or undefined
            (0, common_1.assertParamExists)('addKnownTags', 'requestBody', requestBody);
            const localVarPath = `/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommonKnowTags: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tags/common`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [hideCommon]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnownTags: (hideCommon, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (hideCommon !== undefined) {
                localVarQueryParameter['hideCommon'] = hideCommon;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TagsApiAxiosParamCreator = TagsApiAxiosParamCreator;
/**
 * TagsApi - functional programming interface
 * @export
 */
const TagsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TagsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommonKnownTags(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addCommonKnownTags(requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addKnownTags(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addKnownTags(requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommonKnowTags(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCommonKnowTags(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [hideCommon]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnownTags(hideCommon, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getKnownTags(hideCommon, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.TagsApiFp = TagsApiFp;
/**
 * TagsApi - factory interface
 * @export
 */
const TagsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TagsApiFp)(configuration);
    return {
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommonKnownTags(requestBody, options) {
            return localVarFp.addCommonKnownTags(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addKnownTags(requestBody, options) {
            return localVarFp.addKnownTags(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommonKnowTags(options) {
            return localVarFp.getCommonKnowTags(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [hideCommon]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnownTags(hideCommon, options) {
            return localVarFp.getKnownTags(hideCommon, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TagsApiFactory = TagsApiFactory;
/**
 * TagsApi - object-oriented interface
 * @export
 * @class TagsApi
 * @extends {BaseAPI}
 */
class TagsApi extends base_1.BaseAPI {
    /**
     *
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    addCommonKnownTags(requestBody, options) {
        return (0, exports.TagsApiFp)(this.configuration).addCommonKnownTags(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    addKnownTags(requestBody, options) {
        return (0, exports.TagsApiFp)(this.configuration).addKnownTags(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    getCommonKnowTags(options) {
        return (0, exports.TagsApiFp)(this.configuration).getCommonKnowTags(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [hideCommon]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    getKnownTags(hideCommon, options) {
        return (0, exports.TagsApiFp)(this.configuration).getKnownTags(hideCommon, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TagsApi = TagsApi;
//# sourceMappingURL=api.js.map